/**
 * Mobile-optimized toggle button group — replaces small dropdowns.
 * Big tap targets, monospace labels.
 */
export default function ToggleButtonGroup({ label, options, value, onChange, testId }) {
  return (
    <div data-testid={`toggle-group-${testId}`}>
      <p className="ed-label">{label}</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {options.map((opt) => {
          const v = typeof opt === "string" ? opt : opt.value;
          const text = typeof opt === "string" ? opt : opt.label;
          const active = value === v;
          return (
            <button
              type="button"
              key={v}
              onClick={() => onChange(v)}
              className={`min-h-[56px] px-3 font-mono text-[11px] tracking-[0.14em] uppercase transition-all border ${
                active
                  ? "bg-[#CC1A1A] border-[#CC1A1A] text-white"
                  : "bg-[#0E0E0E] border-[#2A2A2A] text-[#BEB3A6] hover:border-[#CC1A1A] hover:text-white"
              }`}
              data-testid={`toggle-${testId}-${v.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
